export const mockData = {
  hero: {
    title: "Império Ice",
    subtitle: "Ltda.",
    tagline: "Experiência Premium em Gelos Saborizados",
    description: "Qualidade superior que transforma cada momento em uma experiência refrescante única"
  },
  
  manifesto: [
    {
      number: "01",
      title: "Pureza Absoluta",
      description: "Água tratada e filtrada em múltiplas etapas para garantir a máxima pureza em cada cristal de gelo."
    },
    {
      number: "02",
      title: "Sabores Autênticos",
      description: "Essências naturais cuidadosamente selecionadas para criar experiências de sabor incomparáveis."
    },
    {
      number: "03",
      title: "Produção Controlada",
      description: "Processo de fabricação com controle rigoroso de temperatura e qualidade em todas as etapas."
    }
  ],

  products: [
    {
      id: 1,
      name: "Gelos Saborizados",
      weight: "200g",
      description: "Gelos com sabores intensos e refrescantes. Perfeitos para drinks e bebidas especiais.",
      flavors: ["Coco", "Maçã Verde", "Maracujá", "Melancia", "Morango"],
      image: "https://images.unsplash.com/photo-1699400203948-b309ddf47443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjb2xvcmZ1bCUyMHBvcHNpY2xlfGVufDB8fHx8MTc4NTIwNTI2OHww&ixlib=rb-4.1.0&q=85",
      featured: true
    },
    {
      id: 2,
      name: "Gelo em Saco",
      weight: "5kg",
      description: "Gelo cristalino de alta qualidade para festas, eventos e comércio. Derretimento lento.",
      image: "https://images.unsplash.com/photo-1595871277397-08901ed2d7f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjb2xvcmZ1bCUyMHBvcHNpY2xlfGVufDB8fHx8MTc4NTIwNTI2OHww&ixlib=rb-4.1.0&q=85",
      featured: true
    },
    {
      id: 3,
      name: "Gelo em Saco",
      weight: "10kg",
      description: "Nossa maior embalagem. Ideal para grandes eventos, bares e estabelecimentos comerciais.",
      image: "https://images.unsplash.com/photo-1606169109553-aa8c5e4a62b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMHBvcHNpY2xlfGVufDB8fHx8MTc4NTIwNTI2OHww&ixlib=rb-4.1.0&q=85",
      featured: true
    }
  ],

  differentials: [
    {
      title: "Qualidade Certificada",
      description: "Processos certificados e água de pureza comprovada",
      icon: "award"
    },
    {
      title: "Entrega Rápida",
      description: "Logística eficiente com frota própria refrigerada",
      icon: "truck"
    },
    {
      title: "Suporte 24/7",
      description: "Atendimento dedicado para pedidos emergenciais",
      icon: "headphones"
    },
    {
      title: "Melhor Custo-Benefício",
      description: "Preços competitivos sem comprometer a qualidade",
      icon: "tag"
    }
  ],

  resellers: {
    title: "Seja um Revendedor",
    benefits: [
      "Margens de lucro atrativas",
      "Suporte comercial especializado",
      "Material de divulgação incluso",
      "Treinamento sobre os produtos",
      "Condições especiais de pagamento",
      "Exclusividade territorial"
    ],
    cta: "Solicite uma proposta comercial"
  },

  contact: {
    email: "comercial@imperioice.com.br",
    phone: "(11) 98191-9933",
    address: "Rua Segundo Sargento Ananias Holanda de Oliveira, nº 19 - São Paulo/SP",
    social: {
      instagram: "@imperioice",
      facebook: "ImperioIceLtda"
    }
  },

  marqueeText: "QUALIDADE PREMIUM • SABORES AUTÊNTICOS • PUREZA ABSOLUTA • ENTREGA RÁPIDA • "
};
